

const brandSlider = new Swiper('.brand__list', {
  observer: true,
  observeParents: true,
  slidesPerView: 1,
  loop: false,
  spaceBetween: 0,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1280: {
        init: false
      },
    },
});

if(window.matchMedia("(min-width: 1280px)").matches) {
  brandSlider.destroy();
}
$( window ).on( "resize", function() {
  brandSlider.update();
});